import { isDateFuture } from '../../../utils/dateFunctions';
import { checkDiff } from '../../../utils/formValidation/errorCheckingFunctions';
import {
    getCharMaxMessage,
    getNowDateOrEarlierMessage,
    getReqMessage
} from '../../../utils/formValidation/errorMessageFunctions';

export const TEXT_FIELD_LENGTH = 200;

export function validate(newEntry, initialState, type) {
    let newErrors = {};

    if (!newEntry.dateApplied) {
        newErrors = {
            ...newErrors,
            dateApplied: { error: true, message: getReqMessage('Date Applied') }
        };
    } else if (isDateFuture(newEntry.dateApplied)) {
        newErrors = {
            ...newErrors,
            dateApplied: { error: true, message: getNowDateOrEarlierMessage() }
        };
    }

    if (newEntry.businessName?.length > TEXT_FIELD_LENGTH) {
        newErrors = {
            ...newErrors,
            businessName: getCharMaxMessage('Business Name', TEXT_FIELD_LENGTH)
        };
    }

    if (newEntry.jobTitle?.length > TEXT_FIELD_LENGTH) {
        newErrors = {
            ...newErrors,
            jobTitle: getCharMaxMessage('Job Title', TEXT_FIELD_LENGTH)
        };
    }

    if (type === 'edit' && Object.keys(newErrors).length < 1)
        newErrors = checkDiff(newEntry, initialState);

    return newErrors;
}
